module.exports = __webpack_public_path__ + "img/4.c64df97b.png";